import { RcFile } from 'antd/lib/upload';
import { Toast } from '@10d/tend-ui/primitives/Toast';

import { put, post } from 'ui/api/request';

import { AxiosRequestConfig } from 'api/types';
import { RcCustomRequestOptions } from './types';

import { SIZE_LIMIT_ERROR_MESSAGE, MIME_EXTENSIONS_MAP } from './constants';

import { AxiosError } from 'axios';

const changeFromRemoteToLocalPath = (link: string) => {
  return `/upload/${link.split('/').slice(3).join('/')}`;
};

export const onCustomUpLoad = async ({
  file,
  onError,
  onProgress,
  onSuccess,
  withoutConvertPath,
}: Partial<RcCustomRequestOptions>) => {
  try {
    const config: AxiosRequestConfig = {
      onUploadProgress: (event: ProgressEvent) => {
        onProgress && onProgress({ percent: (event.loaded / event.total) * 100, ...event });
      },
    };

    const { fileName: filePath, uploadLink } = await post('/api/upload/link/', {
      fileName: (file as RcFile)?.name,
    });

    const uploadUrl = withoutConvertPath ? uploadLink : changeFromRemoteToLocalPath(uploadLink);

    const type = (file as RcFile)?.type;
    await put(uploadUrl, file, {
      ...config,
      withoutLoginRedirect: true,
      headers: { 'Content-Type': type },
    });
    const response = await post('/api/upload/attachment/', { type, filePath });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess && (onSuccess as (body: any) => void)(response);

    return response;
  } catch (err) {
    const error = err as AxiosError;
    const { status } = error.response || {};

    if (status === 413) {
      Toast.error({ message: `Error ${status}`, description: SIZE_LIMIT_ERROR_MESSAGE });
    }

    console.error(error);
    onError && onError(error);

    throw err;
  }
};

export const converMimeToExtension = (mimeType: string) => {
  for (const type in MIME_EXTENSIONS_MAP) {
    if (mimeType.search(type) !== -1) {
      return mimeType.replace(type, MIME_EXTENSIONS_MAP[type]);
    }
  }
  return mimeType;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatFile = (file: any) => ({
  ...file,
  id: file?.response?.id ?? file?.id,
  file: file?.response?.file ?? file?.file,
  name: file?.fileName ?? file?.name ?? file?.response?.name,
  url: file?.url ?? file?.thumbUrl,
  size: Number(file.size),
});
